/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import styled from 'styled-components'
import { message, Spin } from 'antd'

interface Props {
  requestFunction: () => Promise<any>;
  render: (data: any) => React.ReactNode;
  onResolve?: (data: any, callback: () => void) => void;
}

interface State {
  isLoading: boolean,
  isReady: boolean;
  data?: any;
  error?: any;
}

export default class DetailResolver extends React.Component<Props, State> {
  state = {
    isLoading: true,
    isReady: true,
    data: undefined,
    error: undefined
  }

  componentDidMount () {
    this.loadData()
  }

  loadData = () => {
    const { requestFunction, onResolve } = this.props

    this.setState({ isLoading: true, isReady: !onResolve })

    requestFunction()
      .then((resp: any) => {
        this.setState({ data: resp })
        onResolve && onResolve(resp, this.showContent)
      })
      .catch((resp: any) => {
        message.error(resp.message)
        this.setState({ error: resp.message })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  showContent = () => {
    this.setState({ isReady: true })
  }

  render() {
    return (
      <Container>
        {this.renderContent()}
        {this.renderError()}
        {this.renderLoading()}
      </Container>
    )
  }

  renderContent () {
    const { data, isLoading, isReady } = this.state
    const { render } = this.props

    if (isReady) {
      return data && render(data)
    } else if (!isLoading) {
      return (
        <SpinWrapper>
          <Spin/>
        </SpinWrapper>
      )
    }
  }

  renderLoading () {
    const { isLoading } = this.state

    if (isLoading) {
      return (
        <SpinWrapper>
          <Spin/>
        </SpinWrapper>
      )
    }
  }

  renderError () {
    const { error } = this.state

    if (error) {
      return (
        <ErrorWrapper>
          <h2>El elemento que buscas no existe o está temporalmente no disponible</h2>
          <span>{error}</span>
        </ErrorWrapper>
      )
    }
  }
}

const Container = styled.div`
  position: relative;
  min-height: 200px;
`

const SpinWrapper = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`

const ErrorWrapper = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`